
/**
 * typograph - установка неразрывных пробелов для красивых переносов
 *
 * // Пример вызова
		typograph.init({
			words:     ['за','безо'],               // добавляем свои предлоги
			selectors: ['.section__products_list']  // где искать
		})
 * 
 */

const typograph = {
	defaults: {
		words: [
			'и','а','но','или','не', 'в','о','на','к','с','по', 'за', 'для','без','до','после', 'при','через','об','из','от','над','под','между'
		],
		selectors: ['body']
	},

	setup(options = {}) {
		const { words = [], selectors = [] } = options
		// Объединяем дефолтный и пользовательский списки
		this.words     = [...this.defaults.words, ...words]
		this.selectors = selectors.length ? selectors : this.defaults.selectors

		// Строим паттерн: (^|\s)(слово1|слово2|...)\s
		// 1-я группа — либо начало строки, либо пробельный символ
		// после слов «слово» обязательно обычный пробел
		this.pattern = new RegExp(`(^|\\s)(${this.words.join('|')})\\s`, 'gi')

		this.skipTags = ['SCRIPT','STYLE','PRE','CODE','INPUT','TEXTAREA']
	},

	processRoot(root) {
		const walker = document.createTreeWalker(
			root,
			NodeFilter.SHOW_TEXT,
			null,
			false
		)
		let node
		while (node = walker.nextNode()) {
			const parent = node.parentNode
			if (parent && this.skipTags.includes(parent.nodeName)) continue

			node.nodeValue = node.nodeValue.replace(
				this.pattern,
				(match, pre, word) => `${pre}${word}\u00A0`
			)
		}
	},

	run() {
		this.selectors.forEach(sel => {
			document.querySelectorAll(sel).forEach(root => {
				this.processRoot(root)
			})
		})
	},

	init(options) {
		this.setup(options)
		if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.run())
		else this.run()
	}
}
